module.exports = __webpack_public_path__ + "files/c7b93bed530ff9278396b0ddfd10cd46.png";